/**
 * @file mutations
 */

export default {
    menuList: [],
    cityList: []
};
